import { Subidas } from "@/helpers/subidas";
import { GET } from "@/state/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/subidas")({
  component: RouteComponent,
  loader: async () => (await GET("/admin/subidas")).subidas,
});

function RouteComponent() {
  const subidas = Route.useLoaderData();

  return <Subidas subidas={subidas} admin={false} />;
}
